import { ImmigrationStepService } from '../../../immigration-step.service';
import { CommonService } from 'src/app/core/common.service';
import { StepType } from 'src/app/shared/shared.module';
import {
    getInputField, setAsRequired, setRegexValidation,
    getSelectField, getDateField, setYesNoValues, getTelephoneField,
    MinMaxAgeMustBe, getArrayPickerField, setRequiredWhen,
    setDisableWhen,
    setAsDisabled
} from 'src/app/shared/form';
import { VisaType } from '../../visatypes';
import { isNullOrUndefined } from '../../../../../../app/core/utils';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FieldTooltip } from '../../field-tooltip.enum';
import { map } from 'rxjs/operators';

export class GosiAddition extends VisaType {

    GetRequesterSteps(operations?: () => string[]): StepType[] {
        return [
            {
                label: "Step 1",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.EmpProfileSearch(null, operations),

                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.gpn(),
                            this.gui(),
                           // this.gpnGuiSearchButton(operations)
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.firstName(),
                            this.middleName(),
                            this.lastName()
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.nationalityTypeWithSpecialExpact(),
                            this.nationality(),
                            getSelectField(
                                "citizenshipId",
                                "Citizenship",setAsRequired(
                                this.common.getSelectFieldOptions(this.citizenship$, '',setAsDisabled(this.common.getCitizenshipWrtNationality())))),
                                getSelectField(
                                    "specialExpat",
    
                                    "Special expat",
                                    setYesNoValues(this.common.getSpecialExpactWrtNationalityType(setAsRequired(this.addFieldTooltipWithAdditionalConfig('special expat')
                                ))
                          )),
    
                            // this.onboardingType(
                            //     this.common.getPbTypeWrtNationality()
                            // ),
                            // this.passportNumber(),
                            // getInputField("passportNumber", "Passport number"),
                            getSelectField(
                                "serviceLine.id",
                                "Service line",
                                this.common.getSelectFieldOptions(this.serviceLines$, '',
                                    setAsRequired())
                            ),
                            getSelectField(
                                "subServiceLine.id",
                                "Sub-service line",
                                this.common.getSelectFieldOptions(this.subServiceLines$, "serviceLine.id",
                                    setAsRequired())
                            ),
                            this.rank(),
                            this.officeLocation(),
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            // this.grade(),
                            this.officeLE('EY legal entity'),
                            this.mobileNumber(),
                             getSelectField("immigrationCaseType.id", "Immigration case type", this.common.getRequiredSelectFieldOptions(this.immigrationCaseType$, this.common.getImmigrationCaseTypeSelectFieldOption(setAsRequired()))),

                            this.PersonalEmailAddressOptional('Personal email'),
                                                ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                          getInputField("arabicJobGroup", "Arabic Job group", ),
                          getInputField("arabicVisaDesignation", "Arabic visa designation", ),
                          getDateField("startDate", "Start Date", setAsRequired(
                            setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                                "Please enter a valid date in 'dd-mm-yyyy' format")))
                        ]
                      },
                      {
                        fieldGroupClassName: "row",
                    fieldGroup: [
                      this.IBANNumberOptional('IBAN number'
                    //   ,setAsRequired()
                      ),
                      getInputField(
                        'bankName',
                        'Bank name'
                        // ,setAsRequired()
                         ),
                      this.RequestorName(),
                        ]
                    },
                ]
            }, 
        ];
    }



    GetAccepterSteps(): StepType[] {
        return [
            {
                label: "Step 1",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                          this.visaProcessorByOfficeLE(setAsRequired()),
                        //   this.Requestor()
                        ]
                    }
                ]
            }
        ];
    }


    GetApproverSteps(): StepType[] {

        return [
            {
                label: "Step 1",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.visaProcessorByOfficeLE(
                                setAsRequired()
                                ),
                                this.immigrationStatus(),
                            getInputField(
                                "nationalityIdNumber",
                                "National ID number",
                                // setAsRequired()
                            ),
                            // this.dateOfBirth(MinMaxAgeMustBe(10, 100, 'Date of birth cannot be in the past 10 years or in the future')),
                            // this.dateOfBirthOptional(MinMaxAgeMustBe(10, 100, 'Date of birth cannot be in the past 10 years or in the future')),
                          
                            // this.IBANNumber('IBAN number'),
                        //   this.IBANNumberOptional('IBAN number'),
                        //   this.PersonalEmailAddressOptional('Personal Email ID'),
                            // getInputField(
                            //     'bankName',
                            //     'Bank name',
                                //  setAsRequired()
                                //  ),
                            this.borderNumber(),
                        //   this.Requestor()
                        ]
                    }
                ]
            }
        ];
    }


    private spouseDetails(_buttonAddText: string): FormlyFieldConfig[] {
        return (
            [
                {
                    key: 'formData',
                    type: 'repeat',
                    templateOptions: {
                        addText: `Add ${_buttonAddText}`,
                    },
                    fieldGroupClassName: "row",
                    fieldArray: {
                        fieldGroup: [
                            {
                                fieldGroupClassName: "row",
                                fieldGroup: [
                                    getInputField(
                                        "firstName",
                                        "First name (as per passport)",
                                        // tslint:disable-next-line: max-line-length
                                        setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' }))
                                    ),
                                    getInputField(
                                        "middleName",
                                        "Middle name (as per passport)",
                                        setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' })
                                    ),
                                    getInputField("lastName", "Last name (as per passport)",
                                        // tslint:disable-next-line: max-line-length
                                        setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' }))
                                    ),
                                ]
                            },
                            {
                                fieldGroupClassName: "row",
                                fieldGroup: [
                                    this.dateOfBirth(MinMaxAgeMustBe(10, 100,
                                        'Date of birth cannot be in the past 10 years or in the future'
                                        , { className: 'col-md-4 mb-3' })),
                                    this.placeOfBirth(),
                                    this.gender(),
                                ]
                            },
                            {
                                fieldGroupClassName: "row",
                                fieldGroup: [
                                    getInputField("passportNumber", "Passport number", setAsRequired({ className: 'col-md-4 mb-3' })),
                                    getInputField("iqamaId", "Iqama ID", setAsRequired({ className: 'col-md-4 mb-3' })),
                                    this.nationalityType(),
                                ]
                            }

                        ]
                    },
                },
            ]
        );
    }
    private childrenDetails(_buttonAddText: string): FormlyFieldConfig[] {
        return (
            [
                {
                    key: 'formData',
                    type: 'repeat',
                    templateOptions: {
                        addText: `Add ${_buttonAddText}`,
                    },
                    fieldGroupClassName: "row",
                    fieldArray: {
                        fieldGroup: [
                            {
                                fieldGroupClassName: "row",
                                fieldGroup: [
                                    getInputField(
                                        "firstName",
                                        "First name (as per passport)",
                                        // tslint:disable-next-line: max-line-length
                                        setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' }))
                                    ),
                                    getInputField(
                                        "middleName",
                                        "Middle name (as per passport)",
                                        setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' })
                                    ),
                                    getInputField("lastName", "Last name (as per passport)",
                                        // tslint:disable-next-line: max-line-length
                                        setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' }))
                                    ),
                                ]
                            },
                            {
                                fieldGroupClassName: "row",
                                fieldGroup: [
                                    getDateField("dateOfBirth", "Date of birth", setAsRequired(
                                        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                                            "Please enter a valid date in 'dd-mm-yyyy' format",
                                            this.common.AcceptDateBefore(0, "Date of birth cannot be a future date ",
                                                { className: 'col-md-4 mb-3' })),
                                    )),
                                    this.placeOfBirth(),
                                    this.gender(),
                                ]
                            },
                            {
                                fieldGroupClassName: "row",
                                fieldGroup: [
                                    getInputField("passportNumber", "Passport number", setAsRequired({ className: 'col-md-4 mb-3' })),
                                    getInputField("iqamaId", "Iqama ID", setAsRequired({ className: 'col-md-4 mb-3' })),
                                    this.nationalityType(),
                                ]
                            }

                        ]
                    },
                },
            ]
        );
    }

}
